"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retryable = retryable;
exports.onErr = onErr;
const Backoff_1 = require("./Backoff");
// Delays in milliseconds
const defaultBackoffConfig = new Backoff_1.BackoffConfig(100, 10 * 1000, 1.8);
class TimeoutCtl {
    constructor(backoff, handleTimeout, opts) {
        this.backoff = backoff;
        this.handleTimeout = handleTimeout;
        if (opts.boundWait) {
            this.timeoutDelay = this.backoff.nextDelay();
            this.timeoutHandle = setTimeout(() => this.handleTimeout(this.timeoutDelay), this.timeoutDelay);
            this.label = `${this.timeoutHandle} (${this.timeoutDelay}ms)`;
        }
        else {
            this.label = 'no-timeout';
            this.timeoutDelay = -1;
        }
    }
    clear() {
        if (this.timeoutHandle !== undefined) {
            clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
    reset() {
        this.clear();
        if (this.timeoutDelay !== -1) {
            // re-use existing delay, since its fine
            this.timeoutHandle = setTimeout(() => this.handleTimeout(this.timeoutDelay), this.timeoutDelay);
        }
    }
    setNext() {
        if (this.timeoutDelay !== -1) {
            this.timeoutDelay = this.backoff.nextDelay();
            this.timeoutHandle = setTimeout(() => this.handleTimeout(this.timeoutDelay), this.timeoutDelay);
        }
    }
}
function retryable(cb, giveUpCallback, opts) {
    var _a, _b, _c;
    const backoff = new Backoff_1.Backoff((opts === null || opts === void 0 ? void 0 : opts.backoffCfg) || defaultBackoffConfig);
    const maxTries = (_a = opts === null || opts === void 0 ? void 0 : opts.maxTries) !== null && _a !== void 0 ? _a : 5;
    const boundWait = (_b = opts === null || opts === void 0 ? void 0 : opts.boundWait) !== null && _b !== void 0 ? _b : false;
    const log = (_c = opts === null || opts === void 0 ? void 0 : opts.log) !== null && _c !== void 0 ? _c : ((_) => { });
    function noop() { }
    let clientCancel = noop;
    const timeoutCtl = new TimeoutCtl(backoff, (prevDelay) => {
        log(`Timed out (${prevDelay} millis).  Handle ${timeoutCtl.label}`);
        doResetAndRestart();
    }, { boundWait });
    function runOneTry() {
        log(`try ${backoff.attempts()}.  Handle ${timeoutCtl.label}`);
        clientCancel = cb({
            resetTimeout: () => {
                doResetTimeout();
            },
            cancelTimeout: () => {
                log(`Timeout canceled.  Handle ${timeoutCtl.label}`);
                timeoutCtl.clear();
            },
            forceRetry: () => {
                timeoutCtl.clear();
                doResetAndRestart();
            }
        });
    }
    function doResetTimeout() {
        timeoutCtl.reset();
        log(`Reset: Handle now ${timeoutCtl.label}`);
    }
    // Cancel handler to pass back to caller to clean up everything
    function doCancel() {
        log(`Canceled.  Try ${backoff.attempts()}.  Handle ${timeoutCtl.label}`);
        timeoutCtl.clear();
        clientCancel();
        clientCancel = noop;
    }
    function doResetAndRestart() {
        clientCancel();
        clientCancel = noop;
        if (backoff.attempts() < maxTries) {
            timeoutCtl.setNext();
            setTimeout(runOneTry, 0);
        }
        else {
            log(`Ran out of retries (max ${maxTries}).  Failing.  Handle ${timeoutCtl.label}`);
            giveUpCallback();
        }
    }
    runOneTry();
    return doCancel;
}
// Delays in milliseconds
const defaultErrRetryConfig = new Backoff_1.BackoffConfig(5, 1 * 1000, 2.2);
function delay(millis) {
    return new Promise(resolve => {
        setTimeout(resolve, millis);
    });
}
function onErr(cb, classifyCb, opts) {
    var _a, _b;
    const backoff = new Backoff_1.Backoff((opts === null || opts === void 0 ? void 0 : opts.backoffCfg) || defaultErrRetryConfig);
    const maxTries = (_a = opts === null || opts === void 0 ? void 0 : opts.maxTries) !== null && _a !== void 0 ? _a : 5;
    const log = (_b = opts === null || opts === void 0 ? void 0 : opts.log) !== null && _b !== void 0 ? _b : ((_) => { });
    function oneTry(prevErrs) {
        return cb().catch(err => {
            const shouldRetry = classifyCb(err);
            if (shouldRetry !== undefined) {
                prevErrs.push(err.message || 'unknown');
                if (backoff.attempts() < maxTries) {
                    const delayMS = backoff.nextDelay();
                    log(`retrying after ${delayMS}ms: ${err}: ${shouldRetry}`);
                    return delay(delayMS).then(() => {
                        return oneTry(prevErrs);
                    });
                }
                log(`No more retries (${shouldRetry}) for error: ${prevErrs}`);
                throw err;
            }
            throw err;
        });
    }
    return oneTry([]);
}
//# sourceMappingURL=Retry.js.map